export default __webpack_public_path__ + "static/media/copy.37e02b3d.svg";